import * as react from 'react'
import { useState } from 'react'
import reportesServices from '../../../Services/Reportes/reportes.services'
import DataTable from 'react-data-table-component'
import {DTOTotalHours} from '../../../DTO/Reportes/DTOTotalHours'
import *  as XLSX from 'xlsx'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import { Button, Card, Form,  Col, Row, ToastHeader, CardBody,  } from 'react-bootstrap';
import { BsSearch, BsFileEarmarkExcel } from 'react-icons/bs'
import { DTOWorkingHours } from '../../../DTO/DTOWorkingHours'
import RptTotalHoursSinArchivo from './RptTotalHoursSinArchivo'



export default function RptTotalHours ()
{
    const [Inicio, setInicio] = useState(currentDate()) 
    const [Fin , setFin] = useState(currentDate)
    const [filtro, setFiltro] = useState('')
    const [filteredData, setFilteredData] = useState<Array<DTOTotalHours>> (
        []
    )
    const [filteredDataDet, setFilteredDataDet] = useState <Array<DTOWorkingHours>>(
      []
    )

    const [Data, setData] = useState<Array<DTOTotalHours>> ([])
    const [DataDet , setDataDet ] = useState <Array <DTOWorkingHours>> ([])
    const [showToast, setShowToast] = useState<boolean>(false);
    const [toastMsg, setToastMsg] = useState<string>('');
    const [toastHeader, setToastHeader] = useState<string>('');
    const [toastColor, setToastColor] = useState<string>('');

    const [verSegundoReporte, setVerSegundoReporte] = useState(false);
    const [busquedaTrigger, setBusquedaTrigger] = useState(0);


    const ejecutarBusquedaAmbos = () => {
        generarRptRes(); // Tu función actual para el reporte 1
        generarRptDet(); // Tu función actual para el reporte 1
        
        // Disparador para que el componente hijo (Sin Archivo) reaccione
        setBusquedaTrigger(prev => prev + 1); 
    };



  // function currentDate ():  string {
  //   var today = new Date()
  //   var dd = String(today.getDate()).padEnd(2,'0')
  //   var mm = String(today.getMonth() + 1  ).padStart(2, '0')
  //   var yyyy = today.getFullYear()
  //   return yyyy+'-' + mm + '-'  + dd
  // }

  function currentDate(): string {
  const today = new Date()
  const dd = String(today.getDate()).padStart(2, '0') 
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const yyyy = today.getFullYear()
  return `${yyyy}-${mm}-${dd}`
}

  const generarRptRes = ()  => {
    reportesServices.getRptTotalHours(Inicio, Fin)
    .then((response) => {
      setData(response.data)
      setFilteredData(response.data)
      setToastMsg('Se econtro la siguiente informacion');
      setToastHeader('Informativo');
      setToastColor('success');
      setShowToast(true);

    }) 
    .catch((e:Error)   =>  {
      // alert('Ocurrio un Error'+e.message.toString())
      setToastMsg('No se ha introducido fechas validas')
      setToastHeader('Error')
      setToastColor('danger')
      setShowToast(true)
      return; 
    }  )
  }

  const generarRptDet = () => {
    reportesServices.getRptWorkingHours(Inicio, Fin)
      .then((response) => {
        setDataDet(response.data);
      })
      .catch((e: Error) => {
        setToastMsg('Fechas No Validas');
        setToastHeader('Error');
        setToastColor('danger');
        setShowToast(true);
      });
  };

 




  const columnsConcepts = [
    // {
    //     name: 'EmpNo', 
    //     width : '100px',
    //     selector : (row : DTOTotalHours ) => row.empNo, 
    //     sortable: true, 
    //     filter : true
    // }, 

    // {
    //     name: 'AcNo', 
    //     width : '100px', 
    //     selector : (row : DTOTotalHours) => row.acNo, 
    //     sortable : true, 
    //     filter : true 
    // }, 

    {
      name: 'NumEmpleado', 
      width : '200px', 
      selector: (row :DTOTotalHours) => row.numEmpleado, 
      sortable: true, 
      filter: true 
    },
    {
        name: 'Name', 
        width : '200px', 
        selector: (row: DTOTotalHours)  => row.name, 
        sortable: true, 
        filter: true 

    },  
    {
      name: 'Departamento', 
      width : '200px', 
      selector: (row: DTOTotalHours) => row.departamento, 
      filter: true
    }, 
    // {
    //     name: 'Payroll', 
    //     width : '100px', 
    //     selector : (row : DTOTotalHours) => row.payroll, 
    //     sortable : true, 
    //     filter : true 
    // },
    {
      name: 'Oficina', 
      width: '150px', 
      selector: (row: DTOTotalHours) => row.oficina, 
      sortable : true, 
      filter:  true
    },
    {
      name: 'HoraEntrada', 
      width: '150px', 
      selector : (row: DTOTotalHours) => row.horaEntrada, 
      sortable : true, 
      filter : true 

    }, 
    {
      name: 'HoraSalida', 
      width : '150px', 
      selector: (row: DTOTotalHours) => row.horaSalida, 
      sortable : true, 
      filter: true
    }, 
    // {
    //   name : 'HoraSalidaComer', 
    //   width : '150px', 
    //   selector : (row: DTOTotalHours) =>row.horaSalidaComer, 
    //   sortable : true, 
    //   filter: true
    // }, 
    // {
    //   name : 'HoraEntradaComer', 
    //   width : '160px', 
    //   selector : (row: DTOTotalHours) => row.horaEntradaComer, 
    //   sortable : true, 
    //   filter: true
    // },
    
    {
        name: 'TotalHoursAccumulated', 
        width: '200px', 
        selector : (row: DTOTotalHours ) => row.totalHoursAccumulated, 
        sortable : true, 
        filter : true
    }, 
    // {
    //   name: 'TotalHoursWithMilitaryMinutes', 
    //   with: '50px', 
    //   selector : (row: DTOTotalHours) => row.totalHoursWithMilitaryMinutes, 
    //   sortable: true, 
    //   filter : true
    // },
    
    {
      name : 'Faltas', 
      width : '100px', 
      selector : (row: DTOTotalHours) => row.faltas, 
      sortable : true, 
      filter : true 
    }, 
    {
      name: 'Retardos', 
      width : '100px', 
      selector : (row: DTOTotalHours) => row. retardos, 
      sortable: true, 
      filter : true, 
    }, 
    {
      name: 'HorasExtras', 
      width : '150px', 
      selector : (row: DTOTotalHours) => row.horasExtras, 
      sortable : true, 
      filter: true
    }

     
    

  ]

  const columnsConceptsDet =  [
    [
      {
        name: 'Name' , 
        selector : (row: DTOWorkingHours ) => row.name, 
          sortable : true, 
          filter : true
      }, 
      {
        name: 'EmpNo', 
        
        selector : (row : DTOWorkingHours ) => row.empNo, 
        sortable: true, 
        filter : true
    }
    ]
  ]
    

  const donwloadExel = () => {
    // Filtrar las columnas relevantes para el reporte
    const filteredColumns = filteredData.map(({ numEmpleado, name,  departamento,   horaEntrada, horaSalida , oficina, totalHoursAccumulated , faltas, retardos, horasExtras  }) => ({
      
      
      numEmpleado,
      name,
      departamento, 
      horaEntrada,
      horaSalida,
      oficina, 
      totalHoursAccumulated, 
      faltas, 
      retardos, 
      horasExtras
    }));
  

    const filteredColumnsDet = DataDet.map(({  numEmpleado, name,date, clockIn1 , clockOut1 ,   clockIn2 , clockOut2   , clockIn3 , clockOut3  ,  clockIn4 , clockOut4 ,   clockIn5 , clockOut5, totalHoras, retardo  }) => ({
     
      numEmpleado, 
      name, 
      date, 
      clockIn1 , clockOut1 ,   clockIn2 , clockOut2   , clockIn3 , clockOut3  ,  clockIn4 , clockOut4 ,   clockIn5 , clockOut5, totalHoras , retardo

    
    }));
  


    exportExcel(filteredColumns,  filteredColumnsDet,   'ReporteTotal');
  };
  
  const exportExcel = (jsonData1: any[], jsonData2: any[] ,  fileName: string) => {
    // Encabezados solo para las columnas seleccionadas
    const Heading1 = [[ 'NumEmpleado', 'Name','Departamento',  'HoraEntrada', 'HoraSalida' , 'Oficina' , 'TotalHorasAcumuladas', 'Faltas', 'Retardos', 'HorasExtras'   ]]
    const Heading2 = [[ 'NumEmpleado','name' , 'Date', 'clockIn1' , 'clockOut1' ,   'clockIn2' , 'clockOut2'   , 'clockIn3' , 'clockOut3'  ,  'clockIn4' , 'clockOut4' ,   'clockIn5' , 'clockOut5', 'totalHoras',  'Retardo'  ]];
    

   // Crear libro de trabajo
   const wb = XLSX.utils.book_new();
  
   // Hoja 1
   const ws1: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
   XLSX.utils.sheet_add_aoa(ws1, Heading1);
   XLSX.utils.sheet_add_json(ws1, jsonData1, { origin: 'A2', skipHeader: true });
   XLSX.utils.book_append_sheet(wb, ws1, 'Resumen');
 
   // Hoja 2
   const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
   XLSX.utils.sheet_add_aoa(ws2, Heading2);
   XLSX.utils.sheet_add_json(ws2, jsonData2, { origin: 'A2', skipHeader: true });
   XLSX.utils.book_append_sheet(wb, ws2, 'Detalle');
 
   // Convertir títulos a mayúsculas en ambas hojas
   const capitalizeHeaders = (ws: XLSX.WorkSheet) => {
     const range = XLSX.utils.decode_range(ws['!ref']!);
     for (let C = range.s.c; C <= range.e.c; ++C) {
       const address = XLSX.utils.encode_col(C) + '1';
       if (!ws[address]) continue;
       ws[address].v = ws[address].v.toUpperCase();
     }
   };
 
   capitalizeHeaders(ws1);
   capitalizeHeaders(ws2);
 
   // Escribir y descargar el archivo Excel
   XLSX.writeFile(wb, `${fileName}.xlsx`);
 };
    
  
  

 






  // const donwloadExel = () => {
  //   exportExcel(filteredData, DataDet, 'ReporteTotal'); 
    
    
  // };
  
  // const exportExcel = (jsonData1: any[], jsonData2: any[], fileName: string) => {
  //   const Heading1 = [
  //     [
  //       'EmpNo', 
  //       'AcNo', 
        
  //       'Name', 
  //       'Payroll', 
  //       'Oficina', 
  //       'HoraEntrada', 
  //       'HoraSalida', 
  //       'HoraSalidaComer', 
  //       'HoraEntradaComer', 
  //       'TotalHoursAccumuled', 
  //       'TotalHoursWithMilitaryMinutes', 
  //       'Faltas', 
  //       'Retardos', 
  //       'HorasExtras'
  //     ]
  //   ];
  
  //   const Heading2 = [
  //     [
  //       'EmpNo', 
  //       'AcNo', 
  //       'No',
  //       'Name',
  //       'Date', 
  //       'ClockIn1', 
  //       'ClockOut1', 
        
  //       'ClockIn2', 
  //       'ClockOut2', 
  //       'ClockIn3', 
  //       'ClockOut3', 
  //       'ClockIn4', 
  //       'ClockOut4', 
  //       'ClockIn5', 
  //       'ClockOut5', 
  //       'TotalInTime', 
  //       'esFestivo', 
  //       'TotalHoras'
  //     ]
  //   ];
  
  //   // Crear libro de trabajo
  //   const wb = XLSX.utils.book_new();
  
  //   // Hoja 1
  //   const ws1: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
  //   XLSX.utils.sheet_add_aoa(ws1, Heading1);
  //   XLSX.utils.sheet_add_json(ws1, jsonData1, { origin: 'A2', skipHeader: true });
  //   XLSX.utils.book_append_sheet(wb, ws1, 'Resumen');
  
  //   // Hoja 2
  //   const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
  //   XLSX.utils.sheet_add_aoa(ws2, Heading2);
  //   XLSX.utils.sheet_add_json(ws2, jsonData2, { origin: 'A2', skipHeader: true });
  //   XLSX.utils.book_append_sheet(wb, ws2, 'Detalle');
  
  //   // Convertir títulos a mayúsculas en ambas hojas
  //   const capitalizeHeaders = (ws: XLSX.WorkSheet) => {
  //     const range = XLSX.utils.decode_range(ws['!ref']!);
  //     for (let C = range.s.c; C <= range.e.c; ++C) {
  //       const address = XLSX.utils.encode_col(C) + '1';
  //       if (!ws[address]) continue;
  //       ws[address].v = ws[address].v.toUpperCase();
  //     }
  //   };
  
  //   capitalizeHeaders(ws1);
  //   capitalizeHeaders(ws2);
  
  //   // Escribir y descargar el archivo Excel
  //   XLSX.writeFile(wb, `${fileName}.xlsx`);
  // };
  






    const filtraReporte1 = (e: any)  =>  {
        const searchText = e.target.value.toLowerCase(); 
        setFiltro(searchText)

        const filtered = DataDet.filter((iteam) =>  {
            return (
                (iteam.numEmpleado && iteam.numEmpleado.toString().toLocaleUpperCase().includes(searchText))  || 
                (iteam.name  && iteam.name.toString().toLocaleLowerCase().includes(searchText)   ) 
                

            )
        } )

        setFilteredDataDet(filtered)
       
    } 





    const filtraReporte = (e: any)  =>  {
      const searchText = e.target.value.toLowerCase(); 
      setFiltro(searchText)

      const filtered = Data.filter((iteam) =>  {
          return (
              (iteam.numEmpleado && iteam.numEmpleado.toString().toLocaleUpperCase().includes(searchText))  || 
              (iteam.name  && iteam.name.toString().toLocaleLowerCase().includes(searchText)   ) 
              

          )
      } )

      setFilteredData(filtered)
     
  } 
    
    

    const  generReportes = () => {
      generarRptRes()
      generarRptDet()
    }  

    

    // const filtros = (e: any) => {
    //   filtraReporte(e);
    //   filtraReporte1(e);
    // }

    



    

//     return(
//         <div className='mt-2'> 
//          {/* <Card className="mt-3"> */}
//       <Card.Body>
//         <Form>
//           <Row className="align-items-center">
//             <Col xs={1}>
//               {/* <Form.Label>Desde</Form.Label> */}

//               <Col style={{textAlign: 'center'}} >Desde</Col>
//               <Form.Control
//                 defaultValue={Inicio}
//                 type="date"
//                 name="Inicio"
//                 placeholder="Inicio"
//                 title="Inicio"
//                 alt="Inicio"
//                 data-date-format="YYYY-mm-dd"
//                 onChange={(e) => setInicio(e.target.value)}
//                 size="sm"
//               />
//             </Col>

//             <Col xs={1}>
//               {/* <Form.Label>Hasta</Form.Label> */}
//               <Col style={{textAlign: 'center'}} >Hasta</Col>
//               <Form.Control
//                 defaultValue={Fin}
//                 type="date"
//                 name="Fin"
//                 placeholder="Fin"
//                 title="Fin"
//                 alt="Fin"
//                 onChange={(e) => setFin(e.target.value)}
//                 size="sm"
//               />
//             </Col>

//             <Col xs={2}>
//               <Form.Control
//                 type="text"
//                 size="sm"
//                 placeholder="Search..."
//                 onChange={ (e) =>  {
//                   filtraReporte(e)
//                 }  }
//               //  onChange={filtros}
//                 style={{ height: '10px', padding: '5px' }}
//               />
//             </Col>

//             <Col xs={2}>
//               <Button
//                 // size="sm"
//                 variant="success"
//                 onClick={donwloadExel}
//                 style={{ width: '35%' }}
//               >
//                 <BsFileEarmarkExcel />
//                 &nbsp;Excel
//               </Button>
//             </Col>

//             <Col xs={2}>
//               <Button
//                 variant="primary"
//                 onClick={generReportes} 
//                 style={{ width: '40%' }}
//               >
//                 <BsSearch />
//                 Buscar
//               </Button>
//             </Col>
//           </Row>
//         </Form>
//       </Card.Body>
//     {/* </Card> */}



//     <MsgInformativo
//       show={showToast}
//       msg={toastMsg}
//       header={toastHeader}
//       msgColor={toastColor}
//       closeToast={setShowToast}
//     />
        

//         <Card className='mt-3'> 

//             <Card.Body> 
//                 <div className='ag-theme-alpine' style={{ height: 500, width: '100%'}}>

//                     <DataTable 
//                      noHeader 
//                      defaultSortFieldId={''}
//                      defaultSortAsc = {true}
//                      striped= {true}
//                      dense = {true}
//                      paginationPerPage={10}
//                      pagination 
//                      highlightOnHover 
//                      columns={columnsConcepts}
//                      data={filteredData}
//                      pointerOnHover



//                     />
//                 </div>
//             </Card.Body>
//         </Card>
                


//         </div>  

//     )



// }



return (
    <div className='mt-2'>
        <Card.Body>
            <Form>
                <Row className="align-items-center">
                    <Col xs={1}>
                        <Col style={{ textAlign: 'center' }}>Desde</Col>
                        <Form.Control
                            defaultValue={Inicio}
                            type="date"
                            name="Inicio"
                            onChange={(e) => setInicio(e.target.value)}
                            size="sm"
                        />
                    </Col>

                    <Col xs={1}>
                        <Col style={{ textAlign: 'center' }}>Hasta</Col>
                        <Form.Control
                            defaultValue={Fin}
                            type="date"
                            name="Fin"
                            onChange={(e) => setFin(e.target.value)}
                            size="sm"
                        />
                    </Col>

                    <Col xs={3}>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Buscar por No. Empleado o Nombre..."
                            onChange={(e) => filtraReporte(e)}
                            style={{ height: '30px', padding: '5px' }}
                        />
                    </Col>

                    <Col xs={2}>
                        <Button
                            variant="success"
                            onClick={donwloadExel}
                            className="w-100"
                            size="sm"
                        >
                            <BsFileEarmarkExcel /> Excel
                        </Button>
                    </Col>

                    <Col xs={2}>
                        <Button
                            variant="primary"
                            onClick={ejecutarBusquedaAmbos}
                            className="w-100"
                            size="sm"
                        >
                            <BsSearch /> Buscar en Ambos
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Card.Body>

        <MsgInformativo
            show={showToast}
            msg={toastMsg}
            header={toastHeader}
            msgColor={toastColor}
            closeToast={setShowToast}
        />

        {/* --- PRIMERA TABLA: REPORTE DE HORAS TOTALES (RESUMEN) --- */}
        <Card className='mt-3 shadow-sm'>
            <Card.Header className="bg-light fw-bold">Archivo Excel Cargado Auto  </Card.Header>
            <Card.Body>
                <div className='ag-theme-alpine' style={{ height: 400, width: '100%' }}>
                    <DataTable
                        noHeader
                        striped
                        dense
                        pagination
                        highlightOnHover
                        columns={columnsConcepts}
                        data={filteredData}
                        pointerOnHover
                    />
                </div>
            </Card.Body>
        </Card>

        {/* --- SEGUNDA TABLA: DETALLE SIN ARCHIVO --- */}
        <Card className='mt-4 shadow-sm border-info'>
            <Card.Header className="bg-info text-white fw-bold">Sin archivo</Card.Header>
            <Card.Body>
                <RptTotalHoursSinArchivo 
                    fechaInicio={Inicio} 
                    fechaFin={Fin} 
                    triggerBusqueda={busquedaTrigger}
                />
            </Card.Body>
        </Card>
    </div>
);










}









///ORIGINAL SIN CAMBIOS NO BORRAR 




// import * as React from 'react';
// import { useState } from 'react';
// import RelojChecador from '../../../Services/Catalogos/RelojChecador';
// import DataTable from 'react-data-table-component';
// import * as XLSX from 'xlsx';
// import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
// import { Button, Card, Form, Col, Row } from 'react-bootstrap';
// import { BsSearch, BsFileEarmarkExcel } from 'react-icons/bs';
// import { DTOReporteFechas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteFechas';
// import { DTOReporteChecadas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteChecadas';

// export default function RptFechas() {
//   const [inicio, setInicio] = useState<string>(currentDate());
//   const [fin, setFin] = useState<string>(currentDate());
//   const [filtro, setFiltro] = useState<string>('');
//   const [data, setData] = useState<Array<DTOReporteFechas>>([]);
//   const [filteredData, setFilteredData] = useState<Array<DTOReporteFechas>>([]);
//   const [detalleData, setDetalleData] = useState<Array<DTOReporteChecadas>>([]);
//   const [showToast, setShowToast] = useState<boolean>(false);
//   const [toastMsg, setToastMsg] = useState<string>('');
//   const [toastHeader, setToastHeader] = useState<string>('');
//   const [toastColor, setToastColor] = useState<string>('');


//   function currentDate(): string {
//     const today = new Date();
//     const dd = String(today.getDate()).padStart(2, '0');
//     const mm = String(today.getMonth() + 1).padStart(2, '0');
//     const yyyy = today.getFullYear();
//     return `${yyyy}-${mm}-${dd}`;
//   }

 


//    const generarReporte = () => {
//     let errorMessages: string[] = [];

//     // Llamar al servicio de resumen
//     RelojChecador.getEntradasSalidasFechas(inicio, fin)
//       .then((response) => {
//         setData(response.data);
//         setFilteredData(response.data);
//         setToastMsg('Información de resumen encontrada con éxito');
//         setToastHeader('Informativo');
//         setToastColor('success');
//         setShowToast(true);
//       })
//       .catch((e: Error) => {
//         errorMessages.push('Fechas no válidas para el resumen');
//       });

//     // Llamar al servicio de detalle
//     RelojChecador.getReporteChecadas(inicio, fin)
//       .then((response) => {
//         setDetalleData(response.data);
//         setToastMsg('Información de detalle encontrada con éxito');
//         setToastHeader('Informativo');
//         setToastColor('success');
//         setShowToast(true);
//       })
//       .catch((e: Error) => {
//         errorMessages.push('Fechas no válidas para el detalle');
//       });

//     // Mostrar errores acumulados, si los hay
//     if (errorMessages.length > 0) {
//       setToastMsg(errorMessages.join(' | '));
//       setToastHeader('Error');
//       setToastColor('danger');
//       setShowToast(true);
//     }
//   };
//   const columns = [

//     {
//       name : 'ID', 
//       width: '120px', 
//       selector: (row: DTOReporteFechas) => row.userId, 
//       filter: true
//     }, 
//     {
//       name: 'No. Empleado',
//       width: '120px',
//       selector: (row: DTOReporteFechas) => row.numeroEmpleado,
//       sortable: true,
//       filter: true,
//     },
//     {
//       name: 'Nombre',
//       width: '200px',
//       selector: (row: DTOReporteFechas) => row.nombreEmpleado,
//       sortable: true,
//       filter: true,
//     },

//     {
//       name: 'Departamento',
//       width: '200px',
//       selector: (row: DTOReporteFechas) => row.departamento,
//       sortable: true,
//       filter: true,
//     },

//     {
//       name: 'Oficina',
//       width: '200px',
//       selector: (row: DTOReporteFechas) => row.oficina,
//       sortable: true,
//       filter: true,
      
//     },

//     {
//       name: 'HoraEntrada',
//       width: '200px',
//       selector: (row: DTOReporteFechas) => row.horaEntrada,
//       sortable: true,
//       filter: true,
//     },
//     {
//       name: 'Total Horas',
//       width: '120px',
//       selector: (row: DTOReporteFechas) => row.totalHoras,
//       sortable: true,
//       filter: true,
//     },
//     {
//       name: 'Horas Extras',
//       width: '120px',
//       selector: (row: DTOReporteFechas) => row.horasExtras,
//       sortable: true,
//       filter: true,
//     },{
//       name: 'Faltas',
//       width: '120px',
//       selector: (row: DTOReporteFechas) => row.totalFaltas,
//       sortable: true,
//       filter: true,
//     },
//     {
//       name: 'Retardos',
//       width: '120px',
//       selector: (row: DTOReporteFechas) => row.totalRetardos,
//       sortable: true,
//       filter: true,
//     },
    
//   ];

//   const filtraReporte = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const searchText = e.target.value.toLowerCase();
//     setFiltro(searchText);

//     const filtered = data.filter((item) =>
//       item.numeroEmpleado.toLowerCase().includes(searchText) ||
//       item.nombreEmpleado.toLowerCase().includes(searchText) 
//     );
//     setFilteredData(filtered);
//   };

//   // const exportExcel = () => {
//   //   const heading = [[ 'ID',    'No. Empleado', 'Nombre', 'Total Horas', 'Horas Extras', 'Retardos']];
//   //   const headingDetalle = [
//   //     ['ID', 'No. Empleado', 'Nombre', 'Fecha', 'Entrada 1', 'Salida 1', 'Entrada 2', 'Salida 2', 'Entrada 3', 'Salida 3', 'Total Horas'],
//   //   ];


    
//   //   const wb = XLSX.utils.book_new();
//   //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
//   //   XLSX.utils.sheet_add_aoa(ws, heading);
//   //   XLSX.utils.sheet_add_json(ws, filteredData, { origin: 'A2', skipHeader: true });
    
//   //   const capitalizeHeaders = (ws: XLSX.WorkSheet) => {
//   //     const range = XLSX.utils.decode_range(ws['!ref']!);
//   //     for (let C = range.s.c; C <= range.e.c; ++C) {
//   //       const address = XLSX.utils.encode_col(C) + '1';
//   //       if (ws[address]) ws[address].v = ws[address].v.toUpperCase();
//   //     }
//   //   };
    
//   //   capitalizeHeaders(ws);
//   //   XLSX.utils.book_append_sheet(wb, ws, 'Reporte');
//   //   XLSX.writeFile(wb, 'ReporteFechas.xlsx');
//   // };

//   const exportExcel = () => {
//     const wb = XLSX.utils.book_new();

//     // Hoja de Resumen
//     const headingResumen = [
//       ['ID', 'Nombre', 'NumEmpleado', 'Departamento', 'Oficina',   'Hora Entrada', 'Total Horas', 'Horas Extras', 'Faltas', 'Retardos'],
//     ];
//     const wsResumen: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(wsResumen, headingResumen);
//     XLSX.utils.sheet_add_json(wsResumen, filteredData, { origin: 'A2', skipHeader: true });

//     // Hoja de Detalle
//     const headingDetalle = [
//       ['ID', 'NumEmpleado', 'Nombre', 'Fecha', 'Entrada 1', 'Salida 1', 'Entrada 2', 'Salida 2', 'Entrada 3', 'Salida 3', 'Total Horas'],
//     ];
//     // Usar las fechas y horas en el formato de la plataforma (YYYY-MM-DD y HH:mm:ss)
//     const formattedDetalleData = detalleData.map((item) => ({
//       userId: item.userId,
//       numeroEmpleado: item.numeroEmpleado,
//       nombreEmpleado: item.nombreEmpleado,
//       fecha: item.fecha, // Asumiendo que viene como YYYY-MM-DD
//       entrada1: item.entrada1 || '',
//       salida1: item.salida1 || '',
//       entrada2: item.entrada2 || '',
//       salida2: item.salida2 || '',
//       entrada3: item.entrada3 || '',
//       salida3: item.salida3 || '',
//       totalHoras: item.totalHoras,
//     }));

//     const wsDetalle: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(wsDetalle, headingDetalle);
//     XLSX.utils.sheet_add_json(wsDetalle, formattedDetalleData, { origin: 'A2', skipHeader: true });

//     // Capitalizar encabezados en ambas hojas
//     const capitalizeHeaders = (ws: XLSX.WorkSheet) => {
//       const range = XLSX.utils.decode_range(ws['!ref']!);
//       for (let C = range.s.c; C <= range.e.c; ++C) {
//         const address = XLSX.utils.encode_col(C) + '1';
//         if (ws[address]) ws[address].v = ws[address].v.toUpperCase();
//       }
//     };

//     capitalizeHeaders(wsResumen);
//     capitalizeHeaders(wsDetalle);

//     // Agregar hojas al libro
//     XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen');
//     XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle');

//     // Generar archivo Excel
//     XLSX.writeFile(wb, 'ReporteSemanal.xlsx');
//   };



//   return (
//     <div className="mt-2">
//       <Card>
//         <Card.Body>
//           <Form>
//             <Row className="align-items-center">
//               <Col xs={2}>
//                 <Form.Label>Desde</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={inicio}
//                   onChange={(e) => setInicio(e.target.value)}
//                   size="sm"
//                 />
//               </Col>
//               <Col xs={2}>
//                 <Form.Label>Hasta</Form.Label>
//                 <Form.Control
//                   type="date"
//                   value={fin}
//                   onChange={(e) => setFin(e.target.value)}
//                   size="sm"
//                 />
//               </Col>
//               <Col xs={3}>
//                 <Form.Control
//                   type="text"
//                   placeholder="Buscar por No. Empleado o Nombre..."
//                   onChange={filtraReporte}
//                   size="sm"
//                 />
//               </Col>
//               <Col xs={2}>
//                 <Button variant="success" onClick={exportExcel} size="sm">
//                   <BsFileEarmarkExcel /> Excel
//                 </Button>
//               </Col>
//               <Col xs={2}>
//                 <Button variant="primary" onClick={generarReporte} size="sm">
//                   <BsSearch /> Buscar
//                 </Button>
//               </Col>
//             </Row>
//           </Form>
//         </Card.Body>
//       </Card>

//       <MsgInformativo
//         show={showToast}
//         msg={toastMsg}
//         header={toastHeader}
//         msgColor={toastColor}
//         closeToast={() => setShowToast(false)}
//       />

//       <Card className="mt-3">
//         <Card.Body>
//           <DataTable
//             columns={columns}
//             data={filteredData}
//             pagination
   
//             paginationPerPage={10}
//             striped
//             highlightOnHover
//             dense
//             noHeader
//           />
//         </Card.Body>
//       </Card>
//     </div>
//   );
// }